import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { convertDate, convertDateToIndianFormat } from "../../Helper";
import { GLOBAL_URL } from "../../../API/global";
import MenuItem from "@mui/material/MenuItem";
import { getRequestGlobal } from "../../../API/global";
import { getRequest, postRequest } from "../../../API/IP";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteDialog from "../DeleteDialog";
import edit_button from "../../../images/edit.png";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
} from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import BorderColorTwoToneIcon from "@mui/icons-material/BorderColorTwoTone";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  //textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  height: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  overflow: "auto",
  p: 4,
};

const Preview = ({ formData, setActiveStep }) => {
  const [language, setLanguage] = useState({});
  const [errorsCoProducer, setErrorsCoProducer] = useState({});
  const [CoProduceropen, setCoProducerOpen] = React.useState(false);
  const [selectedPassportFile, setSelectedPassportFile] = useState(null);
  const [country, setCountry] = React.useState("");
  const [indianEntity, setIndianEntity] = React.useState(false);
  const [selectedGovtFile, setSelectedGovtFile] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [prepareDelete, setPrepareDelete] = useState(null);
  const [preEpisodeData, setPreEpisodeData] = useState([]);

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);

  const handleCoProducerChange = (event) => {
    const { name, value, files } = event.target;
    if (files) {
      setCoProducerFormData((prevState) => ({
        ...prevState,
        [name]: files[0],
        ip_application_form_id: formData.id,
      }));
      errorsCoProducer[name] = "";
      setErrorsCoProducer(errorsCoProducer);

      setSelectedFile(files[0]);
    } else {
      setCoProducerFormData((prevState) => ({
        ...prevState,
        [name]: value,
        ip_application_form_id: formData.id,
      }));
      errorsCoProducer[name] = "";
      setErrorsCoProducer(errorsCoProducer);
    }
  };

  const handleIndianEntityChange = (e) => {
    const { name, value } = e.target;
    // console.log(value);

    if (value == 1) {
      setIndianEntity(1);
    } else {
      setIndianEntity(2);
    }
    setCoProducerFormData({
      ...coProducerformData,
      [name]: parseInt(value),
      ip_application_form_id: formData.id,
    });
    errorsCoProducer[name] = "";
    setErrorsCoProducer(errorsCoProducer);
  };

  const handleGovtFileChange = (event) => {
    setSelectedGovtFile(event.target.files[0]);
    const file = event.target.files[0];
    // Do something with the uploadd file
    // console.log(file, "file");
    setCoProducerFormData((prevState) => ({
      ...prevState,
      co_producer_id_proof: file,
      is_gov_id_proof: true,
    }));
  };

  const handlePassportFileChange = (event) => {
    setSelectedPassportFile(event.target.files[0]);
    const file = event.target.files[0];
    // Do something with the uploadd file
    // console.log(file);
    // console.log("Selected Director file:", selectedPassportFile);
    setCoProducerFormData((prevState) => ({
      ...prevState,
      passport_image: file,
      is_passport_image: file,
    }));
    // const formDataToSubmit = new FormData();
    // formDataToSubmit.append('director_id_proof', formData.director_id_proof);
    // You can use FormData API to send the file to the server via fetch or Axios
    // For example:
    // const formData = new FormData();
    // formData.append('file', selectedFile);
    // Then use fetch or Axios to send formData to your backend
  };

  const handleDeleteOpen = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setPrepareDelete(value);
    setOpenDeleteConfirm(true);
  };

  const handleDeleteClose = (e) => {
    e.preventDefault();
    setOpenDeleteConfirm(false);
  };
  const handleDelete = async (e) => {
    e.preventDefault();

    await postRequest("ip_co_producers/delete", {
      co_producer_id: prepareDelete,
      ip_application_form_id: id,
    });
    setOpenDeleteConfirm(false);
    alert("Co producer deleted successfully.");
    await loadpreData();
  };

  const { id = null } = useParams();
  // console.log({ id });

  const [preData, setPredata] = useState([]);
  const [predataFilmfest, setpredataFilmfest] = useState([]);
  const [predataBroadcast, setpredataBroadcast] = useState([]);
  const [preDataInside, setpreDataInside] = useState([]);
  const [preDataOutsid, setpreDataOutsid] = useState([]);
  const [preDataInter, setpreDataInter] = useState([]);
  const [preDataAward, setpreDataAward] = useState([]);
  const [coProducerformData, setCoProducerFormData] = useState({
    co_producer_is: "",
    name: "",
    email: "",
    landline: "",
    mobile: "",
    website: "",
    address: "",
    is_indian_entity: "",
    nationality: "",
    producer_address: "",
    co_producer_id_proof: "",
    passport_image: "",
    is_gov_id_proof: "",
    is_passport_image: "",
    ip_application_form_id: id,
  });

  useEffect(() => {
    loadpreData();
    getRequestGlobal("language_list", {})
      .then((data) => {
        // console.log(data.data)
        setLanguage(data.data);
      })
      .catch((error) => {});
  }, []);

  const loadpreData = async () => {
    const predata = await postRequest("ip_co_producers/list", {
      ip_application_form_id: id,
    });
    if (predata?.data) setPredata(predata?.data);
    const predataFilmfest = await getRequest(`${formData.id}/film-festival`);
    if (predataFilmfest?.data) setpredataFilmfest(predataFilmfest?.data);

    const predataBroadcast = await getRequest(`${formData.id}/ip-broadcasted`);
    if (predataFilmfest?.data) setpredataBroadcast(predataBroadcast?.data);
    const preDataInside = await getRequest(`${formData.id}/ip-inside`);
    if (preDataInside?.data) setpreDataInside(preDataInside?.data);
    const preDataOutsid = await getRequest(
      `${formData.id}/commercially-outside`,
    );
    if (preDataOutsid?.data) setpreDataOutsid(preDataOutsid?.data);
    const preDataInter = await getRequest(
      `${formData.id}/international-competition`,
    );
    if (preDataInter?.data) setpreDataInter(preDataInter?.data);
    const preDataAward = await getRequest(`${formData.id}/ip-award`);
    if (preDataAward?.data) setpreDataAward(preDataAward?.data);
  };

  useEffect(() => {
    const loadData = async () => {
      const episodeResponse = await getRequest(
        `${formData.id}/ip-director`,
        formData,
      );
      const episodeData = episodeResponse.data;
      setPreEpisodeData(episodeData);
    };

    loadData();
  }, [id]);

  const handleRedirectStep = (value) => {
    setActiveStep(value);
  };
  // Handler to redirect to a specific step
  const [expanded, setExpanded] = React.useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const toRoman = (num) => {
    const romanNumerals = [
      ["XL", 40],
      ["X", 10],
      ["IX", 9],
      ["V", 5],
      ["IV", 4],
      ["I", 1],
    ];

    let roman = "";
    for (let [letter, value] of romanNumerals) {
      while (num >= value) {
        roman += letter;
        num -= value;
      }
    }
    return roman;
  };

  return (
    <>
      <div class="container">
        {/* Accordion for Film Details */}
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <button
              onClick={() => handleRedirectStep(0)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            Film Details
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <div class="row">
                <div className="row row-marge">
                  <div class="col-md-6">
                    <p className="titleoffield-view-out">
                      <span>
                        1. Category of the Film{" "}
                        <span className="text-danger"> *</span> :
                      </span>
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p className="titleoffield-view-span">
                      {/* {formData.category == 1
                        ? "Feature Film"
                        : "Non-feature Film"} */}

                      {formData.category == 1
                        ? "Feature Film"
                        : formData.category == 2
                          ? "Non-feature Film"
                          : formData.category == 3
                            ? "Best Debut Director of Indian Feature Film"
                            : formData.category == 4
                              ? "New Horizons (Feature Film)"
                              : ""}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p className="titleoffield-view-span">
                      {formData.category == 4 ? (
                        <>
                          <p className="titleoffield-view-out">
                            <span>
                              <b>(a)</b> Is the film eligible for New Horizons
                              (Feature Film) sub section i.e. it has not been
                              screened at any
                              festival/commercial/public/OTT/Television
                              screening in (depending on the region) the World
                              or India (strike out either the World or India as
                              the case may be) and will not be screened at any
                              festival/commercial/public/OTT/Television anywhere
                              in the World or India (strike out the World or
                              India as the case may be) before it completes its
                              run of screenings at Indian Panorama 2026 at Goa.{" "}
                              <span className="text-danger"> *</span>
                            </span>
                          </p>
                        </>
                      ) : (
                        <></>
                      )}
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p className="titleoffield-view-span">
                      {formData.category == 4 ? (
                        <>
                          {formData.eligible_for_horizons == 1
                            ? "Yes"
                            : formData.eligible_for_horizons == 2
                              ? "No"
                              : ""}
                        </>
                      ) : (
                        <></>
                      )}
                    </p>
                  </div>
                </div>
                <div className="row-marge">
                  <p className="titleoffield-view">
                    2. Title of the Film <span className="text-danger"> *</span>
                  </p>
                  <Container maxWidth="lg">
                    <div className="row">
                      <div class="col-md-6">
                        <p>
                          <span className="">
                            (a) Title of the Film in Roman Script :
                          </span>
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.title_of_film_in_roman}
                          </span>{" "}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="">
                            (b) Title of the Film in Devanagari Script :{" "}
                          </span>
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.title_of_film_in_devanagari}
                          </span>{" "}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="">
                            (c) English translation of the Film title :
                          </span>
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.english_translation_of_film}
                          </span>{" "}
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="">
                            (d) Title of the Film in the script of the language
                            of the Film :
                          </span>
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.title_of_script_langauge}
                          </span>{" "}
                        </p>
                      </div>
                    </div>
                  </Container>
                </div>
                <div className="row-marge">
                  <p>
                    <span className="titleoffield-view">
                      3. Language of the Film{" "}
                      <span className="text-danger"> *</span>
                    </span>
                  </p>
                  <Container maxWidth="lg">
                    <div className="row">
                      <div class="col-md-6">
                        <p>
                          <span className="">(a) Language of the Film:</span>
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.language_id
                              ? language?.[formData.language_id]
                                ? language[formData.language_id]
                                : ""
                              : ""}
                          </span>
                        </p>
                      </div>
                      {/* <div class="col-md-6"> */}
                      {formData.language_id == 20 ? (
                        <>
                          <div className="col-md-6">
                            <p>
                              <span className="">
                                (b) Other langauge name :
                              </span>
                            </p>
                          </div>
                          <div className="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {" "}
                                {formData.other_language_name}
                              </span>
                            </p>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                      {/* </div> */}
                      <div class="col-md-6">
                        <p>
                          <span className="">
                            (c) Whether Subtitled in English language :
                          </span>
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="titleoffield-view-span">
                            {formData.whether_subtitle_english ? "Yes" : "No"}
                          </span>{" "}
                        </p>
                      </div>
                    </div>
                  </Container>
                </div>

                <div className="row-marge">
                  <p className="titleoffield-view">
                    4. Format of the submitted Film{" "}
                    <span className="text-danger"> *</span>
                  </p>
                  <Container maxWidth="lg">
                    <div className="row">
                      <div class="col-md-12">
                        {formData.category == 1 ||
                        formData.category == 3 ||
                        formData.category == 4 ? (
                          <>
                            <p>
                              <strong>
                                (Ensure that the DCP is incorporated with Closed
                                Captioning and Audio Descriptions)
                              </strong>
                            </p>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>

                      <div class="col-md-6">
                        {/* {formData.category == 2 ? (
                          <p>Non Feature Film</p>
                        ) : (
                          <p>Feature Film</p>
                        )} */}
                        {formData.category == 1
                          ? "Feature Film"
                          : formData.category == 2
                            ? "Non-feature Film"
                            : formData.category == 3
                              ? "Best Debut Director of Indian Feature Film"
                              : formData.category == 4
                                ? "New Horizons (Feature Film)"
                                : ""}
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="titleoffield-view-span">
                            {formData.dcp == 1
                              ? "DCP"
                              : formData.dcp == 2
                                ? ""
                                : formData.dcp == 3
                                  ? ""
                                  : ""}
                          </span>
                        </p>
                      </div>

                      {formData.dcp == 1 ? (
                        <>
                          {/* <Container maxWidth='lg'> */}
                          {/* <div className='row'> */}
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                DCP (Unencrypted, DCI Compliant –J2K as per
                                SMPTE Standard) and online downloadable digital
                                file as back-up copy: :
                              </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {formData.dci_compliant_jpeg_2000 == 1
                                  ? "Yes"
                                  : "No"}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                The subtitles to be burned in the picture or in
                                TI CineCanvas™ Format :
                              </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {formData.subtitle_to_be_burned_in_picture == 1
                                  ? "Yes"
                                  : "No"}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                The Hard Disk partition format shall be NTFS or
                                EXT2/EXT3 (with Inode size 128 bytes) :
                              </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {formData.hard_disk_format_ext2_ext3 == 1
                                  ? "Yes"
                                  : "No"}
                              </span>{" "}
                            </p>
                          </div>

                          <div class="col-md-6">
                            <p>
                              <span className="">
                                The DCP should be preferably sent in CRU Drive /
                                Hard Disk :
                              </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {formData.dcp_should_cru_hard_disk == 1
                                  ? "Yes"
                                  : "No"}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">Is the DCP Unencrypted ?</span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {formData.is_dcp_unencrypted == 1
                                  ? "Yes"
                                  : "No"}
                              </span>{" "}
                            </p>
                          </div>
                          {/* </div> */}
                          {/* </Container> */}
                        </>
                      ) : (
                        <></>
                      )}

                      {/* {formData.dcp == 2 ? (
                        <>
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                Is the Blu-ray region free PAL ?
                              </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {" "}
                                {formData.blueray_region_free_pal
                                  ? "Yes"
                                  : "No"}
                              </span>{" "}
                            </p>
                          </div>
                        </>
                      ) : (
                        <></>
                      )} */}

                      {/* {formData.dcp == 3 ? (
                        <>
                          <div class="col-md-6 alignment">
                            <p>
                              <span className="">
                                Is the Pendrive containing HD Files in MP4/ MOV
                                format; Aspect ratio- 1920x1080 HD; Video codec-
                                H.264?
                              </span>
                            </p>
                          </div>

                          <div class="col-md-6 alignment">
                            <p>
                              <span className="titleoffield-view-span">
                                {" "}
                                {formData.is_pendrive_containing_hd_files
                                  ? "Yes"
                                  : "No"}
                              </span>{" "}
                            </p>
                          </div>
                        </>
                      ) : (
                        <></>
                      )} */}

                      <div class="col-md-6">
                        <p>
                          <span className="">
                            {formData.category == 2
                              ? "Value of the DCP (Cost in Rs.)"
                              : "Value of the DCP (Cost in Rs.)"}{" "}
                            :
                          </span>
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>
                          <span className="titleoffield-view-span">
                            {" "}
                            {formData.value_of_dcp_or_blueray}
                          </span>
                        </p>
                      </div>
                    </div>
                  </Container>
                </div>
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>

        {/* Accordion for Producer Details */}
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <button
              onClick={() => handleRedirectStep(1)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            Producer(s) Details
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <p className="m-0">
                <span className="titleoffield-view-out">
                  5. Producer(s) Details <span className="text-danger"> *</span>
                </span>
              </p>
              <Container maxWidth="lg">
                <div class="row">
                  <div className="col-md-12">
                    <div className="card m-1" style={{ width: "100%" }}>
                      <div className="card-body">
                        <div class="row">
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                (a) Whether the Producer is :
                              </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {" "}
                                {formData.producer_is == 1
                                  ? "Individual"
                                  : "Company/Institute/Other Such Entity"}
                              </span>{" "}
                            </p>
                          </div>
                          {/* If Producer Individual */}
                          {formData.producer_is == 1 ? (
                            <>
                              <div class="col-md-6">
                                <p>
                                  <span className="">
                                    Whether any proprietor firm is owned by the
                                    individual making entry :
                                  </span>
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {formData.firm_is_owned_by_individual
                                      ? "Yes"
                                      : "No"}
                                  </span>{" "}
                                </p>
                              </div>
                            </>
                          ) : (
                            /* If Producer Company/Institute/Other Such Entity */
                            <></>
                          )}
                          <Container maxWidth="lg">
                            <div className="row">
                              <div class="col-md-6">
                                <p>
                                  <span className="">
                                    (i){" "}
                                    {formData.producer_is == 2
                                      ? "Name of the production house"
                                      : formData.producer_is == 1 &&
                                          (formData.firm_is_owned_by_individual ==
                                            0 ||
                                            formData.firm_is_owned_by_individual ==
                                              "0")
                                        ? "Name of the producer making the entry"
                                        : "Name of the Firm"}{" "}
                                  </span>
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {formData.name_of_firm}
                                  </span>{" "}
                                </p>
                              </div>
                            </div>
                          </Container>
                          <Container maxWidth="lg">
                            <div className="row">
                              <div class="col-md-6">
                                <p>
                                  <span className="">(ii) E-mail :</span>
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {formData.producer_email}
                                  </span>{" "}
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="">
                                    (iii) Landline (optional) :
                                  </span>
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {formData.producer_landline}
                                  </span>{" "}
                                </p>
                              </div>

                              <div class="col-md-6">
                                <p>
                                  <span className="">(iv) Mobile :</span>
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {formData.producer_mobile}
                                  </span>{" "}
                                </p>
                              </div>

                              <div class="col-md-6">
                                <p>
                                  <span className="">
                                    (v) Website (optional) :
                                  </span>
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {formData.producer_website}
                                  </span>{" "}
                                </p>
                              </div>

                              <div class="col-md-6">
                                <p>
                                  <span className="">(vi) Address :</span>
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {formData.producer_address}
                                  </span>{" "}
                                </p>
                              </div>
                            </div>
                          </Container>
                          <div className="row">
                            <div class="col-md-6">
                              <p>
                                <span className="">
                                  Whether Company is Registered as an Indian
                                  entity - Public Ltd./Private
                                  Ltd./Partnership/Proprietorship or Whether
                                  Indian national (as per the clause number 3(d)
                                  Registration Details) :{" "}
                                </span>
                              </p>
                            </div>
                            <div class="col-md-6">
                              <p>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {formData.company_is_registered_as_indian_entity
                                    ? "Yes"
                                    : "No"}
                                </span>{" "}
                              </p>
                            </div>
                          </div>

                          {/* <div class="col-md-6">
                                    <p><span className="">Is the address same as Producer ? : </span><span className="titleoffield-view-span">  {formData.is_address_same_as_producer ? "Yes" : "No"}</span> </p>
                                </div> */}
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                Attach Photo ID issued by the Govt. of India
                                (for Indian National) :{" "}
                              </span>
                            </p>
                          </div>
                          {/* <div class="col-md-6">
                                        <p><span className="titleoffield-view-span"><FilePresentIcon /> {formData?.documentData?.[1].name}</span>
                                        </p>
                                    </div> */}
                          <div class="col-md-6">
                            <p>
                              <span className="inputoffield">
                                {" "}
                                {!formData?.documentData?.[1] ? (
                                  <></>
                                ) : (
                                  <span className="Attach_Photo_ID">
                                    <a
                                      href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[1]?.file}`}
                                    >
                                      <span>
                                        <FileDownloadIcon />{" "}
                                        {formData?.documentData?.[1]?.name}
                                      </span>
                                    </a>
                                  </span>
                                )}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Container>

              <Container maxWidth="lg">
                <div class="row">
                  {/* <p>6  </p> */}

                  {preData.map((item, index) => (
                    <div className="col-md-12">
                      <div className="card m-1" style={{ width: "100%" }}>
                        <div className="card-body">
                          <p>
                            ({toRoman(index + 1)}){" "}
                            {item.producer_type == "Producer"
                              ? "Producer Details"
                              : "Co-Producer Details"}
                            {/* ({toRoman(index + 1)}) Co-Producer Details{" "} */}
                            <span className="text-danger"> *</span>{" "}
                          </p>
                          <Container>
                            <div className="row">
                              <div className="col-md-6">
                                <p>
                                  <span className="">
                                    Are you the Producer or Co-Producer ?:
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.producer_type == "Producer"
                                      ? "Producer"
                                      : "Co-Producer"}
                                  </span>{" "}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">
                                    Whether Producer/Co-producer is :
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.co_producer_is == 1
                                      ? "Individual"
                                      : "Company / Institute /Other such entity"}
                                  </span>{" "}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">(i) Name :</span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.name}
                                  </span>{" "}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">(ii) E-mail :</span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.email}
                                  </span>{" "}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">
                                    (iii) Landline (optional) :{" "}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.landline}
                                  </span>{" "}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">(iv) Mobile : </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.mobile}
                                  </span>{" "}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">
                                    (v) Website (optional) :{" "}
                                  </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.website}
                                  </span>{" "}
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="">(vi) Address : </span>
                                </p>
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.address}
                                  </span>{" "}
                                </p>
                              </div>
                              <div className="col-md-6">
                                {item.co_producer_is == 2 ? (
                                  <p>
                                    <span className="">
                                      Whether the company(s) is registered as an
                                      Indian Entity, Mention(In accordance with
                                      clause 6.4.2) :{" "}
                                    </span>
                                  </p>
                                ) : (
                                  <p>
                                    Whether the Individual is an Indian
                                    National{" "}
                                  </p>
                                )}
                              </div>
                              <div className="col-md-6">
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.is_indian_entity == 1 ? "Yes" : "No"}
                                  </span>
                                </p>
                              </div>
                              {item.is_indian_entity == 1 ? (
                                <div className="row">
                                  <div className="col-md-6">
                                    <p>
                                      Attach Photo ID issued by the Govt. of
                                      India (for Indian National):
                                    </p>
                                  </div>
                                  {/* <div className='col-md-6'>
                                                                        <p>
                                                                            <p className="titleoffield-view-span" >{item.documents_name}</p>
                                                                        </p>
                                                                    </div> */}

                                  <div class="col-md-6">
                                    <p>
                                      <span className="inputoffield">
                                        <span className="Attach_Photo_ID">
                                          <a
                                            href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${item.file}`}
                                          >
                                            <span>
                                              <FileDownloadIcon />{" "}
                                              {item.documents_name}
                                            </span>
                                          </a>
                                        </span>
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <div className="col-md-6">
                                    <p>Attach copy of Passport:</p>
                                  </div>
                                  <div className="col-md-6">
                                    <p>
                                      {" "}
                                      <b>
                                        {" "}
                                        <a
                                          href={`${GLOBAL_URL}downloadfile/IP/${item.ip_application_form_id}/${item.file1}`}
                                        >
                                          {item.documents_name1}
                                        </a>
                                      </b>
                                    </p>
                                  </div>
                                </>
                              )}

                              <div className="col-md-6">
                                {item.co_producer_is == 2 ? (
                                  <p>
                                    <span className="">
                                      Registration Details :
                                    </span>
                                    <span className="titleoffield-view-span">
                                      {" "}
                                      {item.registration_details}
                                    </span>{" "}
                                  </p>
                                ) : (
                                  ""
                                )}

                                {/* {item.co_producer_is == 2 ? (
                                  <p>
                                    <span className="">
                                      The name of the Producer along with
                                      Co-Producers(s), if any, who is to be
                                      credited in the Certificate :
                                    </span>
                                    <span className="titleoffield-view-span">
                                      {item.name_of_producers}
                                    </span>{" "}
                                  </p>
                                ) : (
                                  ""
                                )}
                                {item.co_producer_is == 1 ? (
                                  <p>
                                    <span className="">
                                      The name of the Producer along with
                                      Co-Producers(s), if any, who is to be
                                      credited in the Certificate :
                                    </span>
                                    <span className="titleoffield-view-span">
                                      {item.name_of_producers}
                                    </span>{" "}
                                  </p>
                                ) : (
                                  ""
                                )} */}
                              </div>
                            </div>
                          </Container>
                        </div>
                      </div>
                    </div>
                  ))}
                  {preData.length ? (
                    <div className="row">
                      <div className="col-md-6">
                        <p>
                          The name of the Producer along with Co-Producers(s),
                          if any ( who is to be credited in the Certificate ):
                        </p>
                      </div>
                      <div class="col-md-6">
                        <p>{formData.co_producer_names}</p>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  <div class="col-md-6">
                    <p>
                      <span className="">
                        (b) Whether the Indian and Foreign Rights Holder are
                        same :{" "}
                      </span>
                    </p>
                  </div>
                  <div class="col-md-6">
                    <p>
                      <span className="titleoffield-view-span">
                        {" "}
                        {formData.whether_indian_foreign_right_holder_same
                          ? "Yes"
                          : "No"}
                      </span>{" "}
                    </p>
                  </div>
                  {formData.whether_indian_foreign_right_holder_same == 0 ? (
                    <>
                      <Container maxWidth="lg">
                        <div className="row">
                          <div class="col-md-6">
                            {formData.right_holder_name ? (
                              <>
                                <p>
                                  <span className="">(i) Name : </span>
                                </p>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div class="col-md-6">
                            {formData.right_holder_name ? (
                              <>
                                <p>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {formData.right_holder_name}
                                  </span>{" "}
                                </p>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">(ii) E-mail : </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {" "}
                                {formData.right_holder_email}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                (iii) Landline (Optional) :{" "}
                              </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {" "}
                                {formData.right_holder_landline}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">(iv) Mobile : </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {" "}
                                {formData.right_holder_mobile}
                              </span>{" "}
                            </p>
                          </div>
                          {/* <div class="col-md-6">
                                            {formData.right_holder_fax ? <><p><span className="" Fax : </span><span className="titleoffield-view-span">  {formData.right_holder_fax}</span> </p></> : <></>}

                                        </div> */}

                          <div class="col-md-6">
                            <p>
                              <span className="">
                                (v) Website (Optional) :{" "}
                              </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {" "}
                                {formData.right_website}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">(vi) Address : </span>
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="titleoffield-view-span">
                                {" "}
                                {formData.right_holder_address}
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                      </Container>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </Container>
            </Container>
            <Container maxWidth="lg">
              <p className="m-0">
                <span className="titleoffield-view-out">
                  6. DCP of the Film to be returned to{" "}
                </span>
              </p>
              <div className="row">
                <div class="col-md-6">
                  <p>
                    <span className="">
                      (a) Is the address same as Producer ? :{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.is_address_same_as_producer ? "Yes" : "No"}
                    </span>{" "}
                  </p>
                </div>
                {formData.is_address_same_as_producer == 0 ? (
                  <>
                    <Container maxWidth="lg">
                      <div className="row">
                        <div class="col-md-6">
                          <p>
                            <span className="">(i) Name : </span>
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.return_address_name}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <span className="">(ii) E-mail : </span>
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.return_address_email}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <span className="">
                              (iii) Landline (Optional) :{" "}
                            </span>
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.return_address_landline}
                            </span>{" "}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <span className="">(iv) Mobile : </span>
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.return_address_mobile}
                            </span>{" "}
                          </p>
                        </div>

                        <div class="col-md-6">
                          <p>
                            <span className="">(v) Website (Optional) : </span>
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.return_website}
                            </span>{" "}
                          </p>
                        </div>

                        <div class="col-md-6">
                          <p>
                            <span className="">(vi) Address : </span>
                          </p>
                        </div>
                        <div class="col-md-6">
                          <p>
                            <span className="titleoffield-view-span">
                              {" "}
                              {formData.return_address}
                            </span>{" "}
                          </p>
                        </div>
                      </div>
                    </Container>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>

        {/* Accordion for Director Details */}
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <button
              onClick={() => handleRedirectStep(2)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            Director(s) Details
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <p className="m-0">
                <span className="titleoffield-view-out">
                  7. Director(s) Details <span className="text-danger"> *</span>
                </span>
              </p>
              <div className="row">
                {preEpisodeData.map((row, index) => (
                  <div className="card m-1">
                    <div className="card-body">
                      <p className="">
                        ({toRoman(index + 1)}) Director Details{" "}
                        <span className="text-danger"> *</span>
                      </p>
                      <Container>
                        <div className="row">
                          <div class="col-md-6">
                            <p>
                              <span className="">(a) Name : </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {row.name}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">(b) E-mail : </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {row.email}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                (c) Landline (Optional) :{" "}
                              </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {row.landline}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">(d) Mobile: </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {row.mobile}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                (e) Website (Optional) :{" "}
                              </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {row.website}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">(f) Address : </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {row.address}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">(i) Indian National : </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {row.indian_nationality ? "Yes" : "No"}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                (ii) Attach Photo ID issued by the Govt. of
                                India (for Indian National) :{" "}
                              </span>
                              <span className="titleoffield-view-span">
                                <a
                                  href={`${GLOBAL_URL}downloadfile/ip/${formData.id}/${row?.documents?.[0]?.file}`}
                                >
                                  <FileDownloadIcon />{" "}
                                  {row?.documents?.[0]?.name}
                                </a>
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                      </Container>
                    </div>
                  </div>
                ))}
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>

        {/* Accordion for Crew Details */}
        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <button
              onClick={() => handleRedirectStep(3)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            Crew Details
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <p className="m-0">
                {" "}
                <span className="titleoffield-view-out">
                  8. Crew Details <span className="text-danger"> *</span>
                </span>
              </p>
              <div className="row">
                <div class="col-md-6">
                  <p>
                    <span className="">(a) Story Writer/ Author : </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.story_write_aurthor}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">(b) Screenplay/ Script Writer : </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.screenplay_script_write}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">(c) Director of Photography : </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.director_of_photography}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">(d) Editor : </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.editor}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">(e) Art Director : </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.art_director}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">(f) Costume Designer : </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.costume_designer}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">(g) Music Director : </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.music_director}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">(h) Sound Recordist : </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.sound_recordist}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">
                      (i) Sound Re-recordist (Optional) :{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.sound_re_recordist}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">(j) Principal Cast : </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.principal_cast}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">
                      (k) Duration/Running time (minutes : seconds) :
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.duration_running_time} :{" "}
                      {formData.duration_running_time_seconds}
                    </span>{" "}
                  </p>
                </div>

                {/* <div class="col-md-6">
                  <p>
                    <span className="">
                      (l) Duration/Running time (in seconds):{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.duration_running_time_seconds}
                    </span>{" "}
                  </p>
                </div> */}

                <Container>
                  <div className="row">
                    <div class="col-md-6">
                      <p>
                        <span className="">(l) No. of DCP (Optional) : </span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.no_of_dcp_blueray}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="">(m) Colour or B&W : </span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.color_b_w}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="">(n) Aspect Ratio : </span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.aspect_ratio}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="">(o) Sound System : </span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.sound_system}
                        </span>{" "}
                      </p>
                    </div>
                  </div>
                </Container>
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>

        {/* Accordion for CBFC Certification */}
        <Accordion
          expanded={expanded === "panel5"}
          onChange={handleChange("panel5")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <button
              onClick={() => handleRedirectStep(4)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            CBFC Certification
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <p className="m-0">
                <span className="titleoffield-view-out">
                  9. CBFC Certification <span className="text-danger"> *</span>
                </span>
              </p>
              <div className="row">
                <div class="col-md-6">
                  <p>
                    <span className="">
                      Whether the Film is certified by CBFC ?:{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.film_is_certified_by_cbfc_or_uncensored == 1
                        ? "Yes"
                        : "No"}
                    </span>{" "}
                  </p>
                </div>
                {formData.film_is_certified_by_cbfc_or_uncensored == 1 ? (
                  <>
                    <div class="col-md-6">
                      <p>
                        <span className="">
                          (a) Date of CBFC certificate :{" "}
                        </span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {convertDateToIndianFormat(
                            formData.date_of_cbfc_certificate,
                          )}
                        </span>{" "}
                      </p>
                    </div>

                    <div class="col-md-6">
                      <p>
                        <span className="">(b) Certification No : </span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {" "}
                          {formData.certificate_no}
                        </span>{" "}
                      </p>
                    </div>

                    <div className="col-md-6">
                      <p>
                        <span className="">
                          (c) Attach Copy Of CBFC Certificate :{" "}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          <a
                            href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[4]?.file}`}
                          >
                            <FileDownloadIcon />
                            {formData?.documentData?.[4]?.name}
                          </a>
                        </span>
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div class="col-md-6">
                      <p>
                        <span className="">
                          (a) Date of Completion of Production :{" "}
                        </span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {convertDateToIndianFormat(
                            formData.date_of_completion_production,
                          )}
                        </span>{" "}
                      </p>
                    </div>
                    <div class="col-md-12">
                      <p>
                        <span className="">
                          (b) Attach Copy Of Declaration As per Clause ( 8.2
                          (C)) :{" "}
                        </span>
                        <span className="titleoffield-view-span">
                          <a
                            href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[3]?.file}`}
                          >
                            <FileDownloadIcon />
                            {formData?.documentData?.[3]?.name}
                          </a>
                        </span>
                      </p>
                    </div>
                  </>
                )}
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>

        {/* Accordion for Other Details */}
        <Accordion
          expanded={expanded === "panel6"}
          onChange={handleChange("panel6")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <button
              onClick={() => handleRedirectStep(5)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            Other Details
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <p className="m-0">
                {" "}
                <span className="titleoffield-view-out">
                  10. Other Details <span className="text-danger"> *</span>
                </span>
              </p>
              <div className="row">
                <div class="col-md-6">
                  <p>
                    <span className="">
                      A. Whether the Film has been completed between 1st August,
                      2025 and 31st July, 2026:{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.film_comletion_during_12month ? "Yes" : "No"}
                    </span>{" "}
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="">
                      B. Whether the Film has been screened in any Indian or
                      International Film Festival and if so, where and
                      when?:{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.film_screened ? "Yes" : "No"}
                    </span>{" "}
                  </p>
                </div>

                {formData.film_screened == 1 ? (
                  <>
                    {predataFilmfest.map((item, index) => (
                      <div className="card m-1">
                        <div className="card-body">
                          <p>({toRoman(index + 1)}) Festival Details</p>
                          <Container>
                            <div className="row">
                              <div class="col-md-6">
                                <p>
                                  <span className="">
                                    Name of the festival :{" "}
                                  </span>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.name_of_festival}
                                  </span>{" "}
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="">
                                    Address of the Festival :{" "}
                                  </span>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.address_of_festival}
                                  </span>{" "}
                                </p>
                              </div>
                              <div class="col-md-6">
                                <p>
                                  <span className="">
                                    Date of the Festival :{" "}
                                  </span>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {convertDateToIndianFormat(
                                      item.date_of_festival,
                                    )}
                                  </span>{" "}
                                </p>
                              </div>
                            </div>
                          </Container>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}

                <div class="col-md-6">
                  <p>
                    <span className="">
                      C. Whether the Film has been shown/broadcast on
                      Internet/TV or other media if so, where and when? :{" "}
                    </span>
                  </p>
                </div>

                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.film_broadcast_tv ? "Yes" : "No"}
                    </span>{" "}
                  </p>
                </div>

                {formData.film_broadcast_tv == 1 ? (
                  <>
                    {predataBroadcast.map((item, index) => (
                      <div className="card m-1">
                        <div className="card-body">
                          <p>({toRoman(index + 1)}) Broadcast Details</p>
                          <Container>
                            <div className="row">
                              <div class="col-md-6">
                                <p>
                                  <span className="">
                                    Streaming Platform :{" "}
                                  </span>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.name}
                                  </span>{" "}
                                </p>
                              </div>
                              {/* <div class="col-md-6">
                                <p>
                                  <span className="">
                                    Address of the Festival :{" "}
                                  </span>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.address}
                                  </span>{" "}
                                </p>
                              </div> */}
                              <div class="col-md-6">
                                <p>
                                  <span className="">Date of Streaming : </span>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {convertDateToIndianFormat(item.date)}
                                  </span>{" "}
                                </p>
                              </div>
                            </div>
                          </Container>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}
                <div class="col-md-6">
                  <p>
                    <span className="">
                      D. Whether the Film has been screened commercially inside
                      India and if so, where and when? :{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.film_screened_inside_india == 1 ? "Yes" : "No"}
                    </span>{" "}
                  </p>
                </div>

                {/* {formData.film_screened_inside_india == 1 ? (
                  <>
                    <div className="card m-1">
                      <div className="card-body">
                        <div class="col-md-6">
                          <p>
                            <span className="">Date Of Release : </span>
                            <span className="titleoffield-view-span">
                              {" "}
                              {convertDate(formData.date_of_release)}
                            </span>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )} */}

                {formData.film_screened_inside_india == 1 ? (
                  <>
                    {preDataInside.map((item, index) => (
                      <div className="card m-1">
                        <div className="card-body">
                          <p>
                            ({toRoman(index + 1)}) Commercially inside Details
                          </p>
                          <Container>
                            <div className="row">
                              <div class="col-md-6">
                                <p>
                                  <span className="">Name of the venue : </span>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.name}
                                  </span>{" "}
                                </p>
                              </div>
                              {/* <div class="col-md-6">
                                <p>
                                  <span className="">
                                    Address of the Festival :{" "}
                                  </span>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {item.address}
                                  </span>{" "}
                                </p>
                              </div> */}
                              <div class="col-md-6">
                                <p>
                                  <span className="">Date of Screening : </span>
                                  <span className="titleoffield-view-span">
                                    {" "}
                                    {convertDateToIndianFormat(item.date)}
                                  </span>{" "}
                                </p>
                              </div>
                            </div>
                          </Container>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}

                <div class="col-md-6">
                  <p>
                    <span className="">
                      E. Whether the Film has been screened commercially outside
                      India, and if so, where and when? :{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.film_screened_outside_india ? "Yes" : "No"}
                    </span>{" "}
                  </p>
                </div>
                {formData.film_screened_outside_india == 1 ? (
                  <>
                    {preDataOutsid.map((item, index) => (
                      <div className="card m-1">
                        <div className="card-body">
                          <div className="row">
                            <div class="col-md-6">
                              <p>
                                <span className="">
                                  ({toRoman(index + 1)}) Name of the country
                                  screened screened :{" "}
                                </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.name}
                                </span>{" "}
                              </p>
                            </div>
                            {/* <div class="col-md-6">
                              <p>
                                <span className="">
                                  Address of the festival :{" "}
                                </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {item.country}
                                </span>{" "}
                              </p>
                            </div> */}
                            <div class="col-md-6">
                              <p>
                                <span className="">
                                  Date of the screening :{" "}
                                </span>
                                <span className="titleoffield-view-span">
                                  {" "}
                                  {convertDateToIndianFormat(item.release_date)}
                                </span>{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}

                <div class="col-md-6">
                  <p>
                    <span className="">
                      F. Whether the Film has participated in any International
                      Competition, and if so, where and when? :
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.film_participated_compentitaion ? "Yes" : "No"}
                    </span>{" "}
                  </p>
                </div>

                {formData.film_participated_compentitaion == 1 ? (
                  <>
                    {preDataInter.map((item, index) => (
                      <div className="card m-1">
                        <div className="card-body">
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                ({toRoman(index + 1)}) Name of the festival
                                :{" "}
                              </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {item.name}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">Address : </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {item.address}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">Date of the festival : </span>
                              <span className="titleoffield-view-span">
                                {convertDateToIndianFormat(item.date)}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}

                <div class="col-md-6">
                  <p>
                    <span className="">
                      G. Details of the Award won, if any :
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.is_ip_award ? "Yes" : "No"}
                    </span>{" "}
                  </p>
                </div>

                {formData.is_ip_award == 1 ? (
                  <>
                    {preDataAward.map((item, index) => (
                      <div className="card m-1">
                        <div className="card-body">
                          <div class="col-md-6">
                            <p>
                              <span className="">
                                ({toRoman(index + 1)}) Name of the Festival :
                              </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {item.name}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">Address :</span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {item.address}
                              </span>{" "}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <p>
                              <span className="">Date of the festival :</span>
                              <span className="titleoffield-view-span">
                                {convertDateToIndianFormat(item.date)}
                              </span>
                            </p>
                          </div>

                          <div class="col-md-6">
                            <p>
                              <span className="">
                                Name of the Awards won(if any) :
                              </span>
                              <span className="titleoffield-view-span">
                                {" "}
                                {item.details}
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <></>
                )}

                <div class="col-md-6">
                  <p>
                    <span className="">
                      H. Whether Film's distribution is limited to India only
                      :{" "}
                    </span>
                  </p>
                </div>
                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.film_distribution_limited_to_india_only
                        ? "Yes"
                        : "No"}
                    </span>{" "}
                  </p>
                </div>

                <div class="col-md-6">
                  <p>
                    <span className="">
                      I. Whether, it is Director's Debut Film :{" "}
                    </span>
                  </p>
                </div>

                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.is_directore_debute_film ? "Yes" : "No"}
                    </span>{" "}
                  </p>
                </div>

                <div class="col-md-6">
                  <p>
                    {formData.is_directore_debute_film == 1 ? (
                      <>
                        <span className="">
                          Enclosed the Declaration Letter (as per the clause No.
                          8.2c) :{" "}
                        </span>
                      </>
                    ) : (
                      <></>
                    )}
                  </p>
                </div>

                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {formData.category == 3 ? (
                        <>
                          {formData.enclosed_the_declaration_letter
                            ? "Yes"
                            : ""}
                        </>
                      ) : (
                        <></>
                      )}{" "}
                    </span>{" "}
                  </p>

                  <p>
                    <span className="titleoffield-view-span">
                      {formData.category == 1 ||
                      formData.category == 2 ||
                      formData.category == 4 ? (
                        <>
                          {formData.enclosed_the_declaration_letter
                            ? "Yes"
                            : "No"}
                        </>
                      ) : (
                        <></>
                      )}{" "}
                    </span>{" "}
                  </p>
                </div>

                <div class="col-md-6">
                  <p>
                    <span className="">
                      J. Whether it can be confirmed that the film has neither
                      released nor planned to be releases in India/Outside India
                      until it has completed its run at IFFI 2026?
                    </span>
                  </p>
                </div>

                <div class="col-md-6">
                  <p>
                    <span className="titleoffield-view-span">
                      {" "}
                      {formData.confirmation_neither_released_nor_planned
                        ? "Yes"
                        : "No"}
                    </span>{" "}
                  </p>
                </div>
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>
        {/* Accordion for Documents */}
        <Accordion
          expanded={expanded === "panel7"}
          onChange={handleChange("panel7")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <button
              onClick={() => handleRedirectStep(6)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            Documents
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <p className="m-0">
                <span className="titleoffield-view-out">
                  11. Documents (For Feature Film, Non-Feature Film and films
                  under Best Debut Director of Indian Feature Film, New Horizons
                  (Feature Film)) <span className="text-danger"> *</span>
                </span>
              </p>
              <div className="row">
                <p>
                  11.1.
                  <span className="">
                    Upload Documents <span className="text-danger"> *</span>{" "}
                    :{" "}
                  </span>
                </p>
                <Container>
                  <div className="row">
                    <div className="col-md-6">
                      <p>
                        <span className="">
                          (a) Authorisation Letter in Favour Of NFDC (FORM
                          I.P.-II) in PDF :{" "}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          <a
                            href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[5]?.file}`}
                          >
                            <FileDownloadIcon />
                            {formData?.documentData?.[5]?.name}
                          </a>
                        </span>{" "}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="">
                          (b) Declaration Letter (As Per The Clause No 8.2(C))
                          in PDF :
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          <a
                            href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[6]?.file}`}
                          >
                            <FileDownloadIcon />
                            {formData?.documentData?.[6]?.name}
                          </a>
                        </span>{" "}
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="">
                          (c) Synopsis in English (Not Exceeding 150 Words) :
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {formData?.synopsis || "Not provided"}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="">
                          ((d) Director(s) Profile (Not Exceeding 100 words) &
                          Note (Not Exceeding 30 words) :
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {formData?.director_note || "Not provided"}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="">
                          e) Producer(s) Profile (Not Exceeding 100 words) :{" "}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          {formData?.producer_note || "Not provided"}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="">
                          (f) Details Of Cast & Crew In .doc Format :{" "}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          <a
                            href={`${GLOBAL_URL}downloadfile/IP/${formData.id}/${formData?.documentData?.[10]?.file}`}
                          >
                            <FileDownloadIcon />
                            {formData?.documentData?.[10]?.name}
                          </a>
                        </span>{" "}
                      </p>
                    </div>
                  </div>
                </Container>
                <p>
                  11.2. Following must be mailed to{" "}
                  <span style={{ color: "#AD4172", fontWeight: "800" }}>
                    indianpanorama@nfdcindia.com:-
                  </span>
                </p>
                <Container>
                  <div className="row">
                    <div className="col-sm-12 col-lg-12">
                      <p>
                        A:- &nbsp;Film stills (5 nos.), 200-300 dpi
                        <sup className="text-danger"> *</sup>
                      </p>
                      <p>
                        B:- &nbsp;Director(s) working stills (2 nos.), 200-300
                        dpi<sup className="text-danger"> *</sup>
                      </p>
                      <p>
                        C:- &nbsp;Producer(s) still or logo, 200-300 dpi
                        <sup className="text-danger"> *</sup>
                      </p>
                      <p>
                        D:- &nbsp;Posters<sup className="text-danger"> *</sup>
                      </p>
                    </div>
                  </div>
                </Container>
                <Container>
                  <div className="row">
                    <div class="col-md-6">
                      <p>
                        <span className="">
                          Whether the requisite documents(s) at serial no. 11.2-
                          (A) (B) (C) & (D) are sent by email{" "}
                          <span className="text-danger"> *</span>:{" "}
                        </span>
                      </p>
                    </div>
                    <div class="col-md-6">
                      <p>
                        <span className="titleoffield-view-span">
                          <AttachEmailIcon />{" "}
                          {formData.requisite_documents ? "Yes" : "No"}
                        </span>{" "}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div class="col-md-12">
                      <p>
                        <span className="titleoffield-view-out">
                          12. Online downloadable digital file as back-up copy:
                          <span className="text-danger"> *</span>
                        </span>
                      </p>
                      12.1 Online Link :{" "}
                      <a href={`${formData?.online_link}`}>
                        {formData?.online_link}
                      </a>
                    </div>
                    <div class="col-md-6">
                      12.2 Online Password: {formData?.online_password}
                    </div>
                  </div>
                </Container>
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

export default Preview;
